import { Switch } from 'antd'
import React from 'react'

function ToggleWithLabel() {
  return (
    <Switch className='auf-toggle' checkedChildren="1" unCheckedChildren="0" />
  )
}

export default ToggleWithLabel